import { ListItemButton, ListItemButtonProps, SxProps, Theme, useTheme } from "@mui/material";
import { forwardRef } from "react";

import { NavItemType } from "@/types/menu";

export type NavItemButtonProps = {
  item: NavItemType;
  level: number;
  drawerOpen: boolean;
  isParents?: boolean;
  onClick?: (id: string | undefined) => void;
  href?: string;
  target?: string;
} & ListItemButtonProps;

const NavItemButton = forwardRef<HTMLDivElement, NavItemButtonProps>(
  ({ item, level, drawerOpen, onClick, ...props }, ref) => {
    const theme = useTheme();

    const drawerOpenStyles: SxProps<Theme> = {
      zIndex: 1201,
      pl: `${level * 20}px`,
      pr: "20px",
      py: "11px",
      mb: "4px",
    };

    const drawerClosedStyles: SxProps<Theme> = {
      pl: "20px",
      pr: "20px",
      py: "20px",
      mb: "8px",

      maxWidth: "60px",
      maxHeight: "60px",
      alignItems: "center",
      mx: "auto",
    };

    const styles = drawerOpen ? drawerOpenStyles : drawerClosedStyles;

    return (
      <ListItemButton
        ref={ref}
        {...props}
        disabled={item.disabled}
        onClick={() => onClick && onClick(item.id)}
        sx={{
          zIndex: 1201,
          ...styles,
          justifyContent: "center",
          borderRadius: drawerOpen ? "12px" : "16px",
          color: "#262626",
          "&:hover": {
            borderRadius: "12px",
          },
          "&.Mui-selected": {
            bgcolor: theme.palette.background.paper,
            color: "#202020",
            borderRadius: "12px",
            boxShadow: "0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 6px -1px rgba(0, 0, 0, 0.16)",
            "&:hover": {
              bgcolor: theme.palette.background.paper,
            },
          },
        }}
      />
    );
  }
);

NavItemButton.displayName = "NavItemButton";

export default NavItemButton;
